import React, { useEffect } from "react";
import { useAppDispatch } from "../../../../state/store";
import { getListAction } from "../../../../state/usecase/admin/list/actions";
import { AdminListProvider } from "../../../provider/AdminListProvider";
import { AdminListFilter } from "./components/AdminListFilter";
import { AdminListTable } from "./components/AdminListTable";

export function AdminListPage() {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(getListAction());
    }, [dispatch]);

    return (
        <div className={"admin_list_page"}>
            <AdminListProvider>
                <AdminListFilter />
                <AdminListTable />
            </AdminListProvider>
        </div>
    );
}
